import { render, staticRenderFns } from "./服务协议.vue?vue&type=template&id=773a2ce8&scoped=true"
import script from "./服务协议.vue?vue&type=script&lang=js"
export * from "./服务协议.vue?vue&type=script&lang=js"
import style0 from "./服务协议.vue?vue&type=style&index=0&id=773a2ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a2ce8",
  null
  
)

export default component.exports